import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import RepairDetails from "./sections/RepairDetails";
import DetailedDomains from "./sections/DetailedDomains";
import DiscussYourCase from "./sections/DiscussYourCase";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <RepairDetails />
      <DetailedDomains />
      <DiscussYourCase />
      <Footer />
    </div>;
}